module.exports = __webpack_public_path__ + "static/media/soulling-punk.6f8f1ba4.jpg";